import { FormControl, FormLabel, HStack, InputProps } from '@chakra-ui/react';
import { DatePicker } from '@jurnee/common/src/components/DatePicker';
import { add, getNextDay } from '@jurnee/common/src/utils/dates';
import { useTranslation } from 'react-i18next';
import { DEFAULT_BOOKING_DEADLINE } from '../utils/bookings';
import { BookingDeadlineTooltip } from './BookingDeadlineTooltip';

interface Props {
  selected: Date | null;
  label: string;
  bookingDeadline?: number;
  isRequired?: boolean
  inputProps?: InputProps;
  onChange(from: Date | null): void;
}

export function FromDatePicker(props: Props) {
  const { t } = useTranslation('common');
  const tomorrow = getNextDay(new Date());
  const minDate = add(tomorrow, props.bookingDeadline || DEFAULT_BOOKING_DEADLINE);
  const hasDeadlineTooltip = props.selected && props.selected < minDate;

  return (
    <FormControl id="date" isRequired={props.isRequired}>
      <HStack justifyContent="space-between">
        <FormLabel>{ props.label }</FormLabel>
        { hasDeadlineTooltip && <BookingDeadlineTooltip position="absolute" top={0} right={0} /> }
      </HStack>

      <DatePicker
        popperPlacement="bottom-start"
        dateFormat="dd MMM yyyy"
        selected={props.selected}
        minDate={tomorrow}
        placeholderText={t('fields.date.placeholder')}
        onChange={props.onChange}
        inputProps={props.inputProps}
        disabledKeyboardNavigation
      />
    </FormControl>
  );

}